module.exports = __webpack_public_path__ + "static/media/FCP01@m.41bc9964.jpg";